import { render, staticRenderFns } from "./account_info.vue?vue&type=template&id=1422a39a&scoped=true&"
import script from "./account_info.vue?vue&type=script&lang=js&"
export * from "./account_info.vue?vue&type=script&lang=js&"
import style0 from "./account_info.vue?vue&type=style&index=0&id=1422a39a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422a39a",
  null
  
)

export default component.exports